import {Paper, type PaperProps} from '@mui/material';
import {type ReactNode} from 'react';

const GenericPaper = ({
  height,
  children,
  outlined = true,
  dataTestId,
  sx,
  ...rest
}: {
  height?: string;
  children: ReactNode;
  outlined?: boolean;
  dataTestId?: string;
} & PaperProps) => {
  return (
    <Paper
      variant={outlined ? 'outlined' : undefined}
      sx={{height, ...sx}}
      elevation={0}
      data-testid={dataTestId}
      {...rest}
    >
      {children}
    </Paper>
  );
};

export default GenericPaper;
